var map = {
	"./ACT.jpg": 363,
	"./ACT.webp": 162,
	"./AP1.webp": 164,
	"./AP2.webp": 165,
	"./AP3.webp": 166,
	"./AP4.webp": 167,
	"./AS.jpg": 364,
	"./AS.webp": 163,
	"./AssociatePartner.jpg": 365,
	"./BB.jpg": 366,
	"./BB.webp": 161,
	"./BY.jpg": 367,
	"./BY.webp": 368,
	"./BYJU.webp": 168,
	"./C.jpg": 369,
	"./C.webp": 370,
	"./H.jpg": 371,
	"./H.webp": 372,
	"./I.jpg": 373,
	"./I.webp": 374,
	"./INCUBATION.webp": 169,
	"./IP.webp": 170,
	"./LWT.jpg": 375,
	"./LWT.webp": 376,
	"./OB.jpg": 377,
	"./OB.webp": 378,
	"./SS.jpg": 379,
	"./SS.webp": 380,
	"./TBI.jpg": 381,
	"./TBI.webp": 159,
	"./TBU.webp": 171,
	"./TCF.jpg": 382,
	"./TCF.webp": 383,
	"./TP.webp": 172,
	"./TS.png": 384,
	"./TS.webp": 160,
	"./TT.jpg": 385,
	"./TT.webp": 82,
	"./UI.jpg": 386,
	"./UI.webp": 387,
	"./Z.jpg": 388,
	"./Z.webp": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;